import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { TemplateWindowComponent } from './template-window/template-window.component';
import { SharedModule } from '../../common/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RemindPasswordComponent } from './remind-password/remind-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { LayoutModule } from '../../common/layout/layout.module';

const DECLARATIONS = [
    LoginComponent,
    RemindPasswordComponent,
    NewPasswordComponent,
    TemplateWindowComponent,
];

@NgModule({
    imports: [
        CommonModule,
        AuthRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        LayoutModule
    ],
    declarations: [
        ...DECLARATIONS,
    ],
    exports: [
        ...DECLARATIONS
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class AuthModule {
}
